import React from 'react'
import styled from 'styled-components'
import {colors, utils} from '../styles'

const EmbedWrapper = styled.figure`
  width: 37rem;
  max-width: 100vmin;
`
const Embed = styled.div`
  position: relative;
  padding-top: 56.25%;
  > iframe {
    ${utils.absFill(0)}
    width: 100%;
    height: 100%;
    border: 3px solid ${colors.blueText};
  }
`

export default ({children}) => (
  <EmbedWrapper>
    <Embed>
      { children }
    </Embed>
  </EmbedWrapper>
)



/** WEBPACK FOOTER **
 ** ./src/components/Embed.js
 **/